/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S2_Li6Inputs */

const tr_onbilgi_s2_li6 = /** @type {(inputs: Onbilgi_S2_Li6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kargo entegrasyonu (Geliver)`)
};

const en_onbilgi_s2_li6 = /** @type {(inputs: Onbilgi_S2_Li6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipping integration (Geliver)`)
};

const de_onbilgi_s2_li6 = /** @type {(inputs: Onbilgi_S2_Li6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versandintegration (Geliver)`)
};

const ru_onbilgi_s2_li6 = /** @type {(inputs: Onbilgi_S2_Li6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Интеграция доставки (Geliver)`)
};

/**
* | output |
* | --- |
* | "Shipping integration (Geliver)" |
*
* @param {Onbilgi_S2_Li6Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s2_li6 = /** @type {((inputs?: Onbilgi_S2_Li6Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S2_Li6Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s2_li6(inputs)
	if (locale === "de") return de_onbilgi_s2_li6(inputs)
	if (locale === "ru") return ru_onbilgi_s2_li6(inputs)
	return tr_onbilgi_s2_li6(inputs)
});